export default "__VITE_ASSET__CG8g35nR__"